<template>
    <div class="phone-input-wrapper">
        <div class="phone-input-container flex items-center">
            <div class="country-code-selector mr-2 relative">
                <button type="button" @click="displayCodes" class="code-select-button text-base text-[var(--charcoal-dark)] border border-[var(--bone)] focus:border-[var(--primary)] rounded-full h-9 px-3 py-1 bg-white outline-0 flex items-center w-20">
                    <span class="flag mr-1">{{ phone_flag }}</span>
                    <span class="code mr-1">{{ phone_ext }}</span>
                    <svg class="chevron" width="12" height="8" viewBox="0 0 12 8" fill="none">
                        <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>

                <div v-if="show_codes" class="country-dropdown text-base text-[var(--charcoal-dark)] border border-[var(--bone)] rounded-lg left-0 top-full absolute bg-white min-w-80 max-h-96 overflow-x-auto z-10">
                    <div class="dropdown-search py-2 px-3">
                        <input 
                            @keyup="searchCodes" 
                            type="text" 
                            placeholder="Search country..." 
                            class="search-input text-base text-[var(--charcoal-dark)] border border-[var(--bone)] focus:border-[var(--primary)] rounded-full h-9 px-3 py-1 bg-white w-full outline-0" 
                        />
                    </div>

                    <div @mouseleave="hideCodes" class="country-list">
                        <button 
                            type="button"
                            v-for="(ele, idx) in country_codes" 
                            @click="() => updateExt(ele.code, ele.key, ele.flag)"
                            :key="`phone-int-code-${idx}`" 
                            class="country-option text-sm w-full text-left px-3 py-0.5"
                        >
                            <span class="country-flag">{{ ele.flag }}</span>
                            <span class="country-name mx-2">{{ ele.name }}</span>
                            <span class="country-code">{{ ele.code }}</span>
                        </button>
                    </div>
                </div>
            </div>

            <input 
                @keydown="updateParent" 
                @change="updateParent" 
                type="text" 
                id="phone_number" 
                name="phone_number"
                v-model="phone_num" 
                v-mask="'################'" 
                class="phone-number-input text-base text-[var(--charcoal-dark)] border border-[var(--bone)] focus:border-[var(--primary)] rounded-full h-9 px-3 py-1 bg-white w-full outline-0"
                placeholder="(Area Code) Phone Number" 
            />
        </div>
    </div>
</template>

<script>
import { CountryCodes } from '../../utils/geoUtils';
import { mask } from 'vue-the-mask';

export default {
        name: "IntPhoneNumber",

        props: {
                current_phone_number: String,
                current_phone_code: String,
        },

        directives: {
                mask
        },

        mounted() {
                this.phone_num = this.current_phone_number;
                this.phone_ext = this.current_phone_code;
                this.phone_flag = this.getFlagEmoji(this.phone_ext, true);
                
                // Add click outside listener
                document.addEventListener('click', this.handleClickOutside);
        },

        unmounted() {
                // Remove click outside listener
                document.removeEventListener('click', this.handleClickOutside);
        },

        created() {
                this.country_codes = CountryCodes.getCodes();
        },

        data: () => {
                return {
                        phone_ext: "+1",
                        phone_num: "",
                        phone_flag: "",
                        phone_cnt: "us",
                        country_codes: [],
                        show_codes: false,
                        search_term: "",
                }
        },

        methods: {
                handleClickOutside(event) {
                        // Close dropdown if click is outside the component
                        const dropdown = this.$el?.querySelector('.country-code-selector');
                        if (dropdown && !dropdown.contains(event.target)) {
                                this.hideCodes();
                        }
                },

                getFlagEmoji(countryCode, useExt = false) {
                        let code = countryCode;
                        if (useExt) {
                                const codes = CountryCodes.getCodes();
                                const result = codes.filter((c) => c.code === code);
                                if (result.length > 0) {
                                        code = result[0].key;
                                }
                        }
                        const codePoints = code
                                .toUpperCase()
                                .split('')
                                .map(char => 127397 + char.charCodeAt());
                        return String.fromCodePoint(...codePoints);

                },

                displayCodes() {
                        this.show_codes = true;
                },

                hideCodes() {
                        this.show_codes = false;
                },

                searchCodes(evt) {
                        const codes = CountryCodes.getCodes();
                        const val = evt.target.value;
                        if (val.trim() === "") {
                                this.country_codes = codes;
                        } else {
                                this.country_codes = codes.filter((c) => {
                                        return (c.name.toLowerCase().includes(val.toLowerCase()) || c.code.includes(`${val}`));
                                });
                        }

                },

                updateExt(ext, cnt, flag) {
                        this.phone_ext = ext;
                        this.phone_cnt = cnt;
                        this.show_codes = false;
                        this.phone_flag = flag;
                        this.updateParent();
                },

                updateParent() {
                        const { phone_ext, phone_num } = this;
                        this.$emit('onphoneupdate', { phone_ext, phone_num });
                }
        }
}
</script>